export function playAudio(src) {
  new Audio(src).play();
}
